import { createSlot } from "lib/@components/slot/create-slot"

export const ManuallySelectedScheduleItem = createSlot("ManuallySelectedScheduleItem")
